import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import { type QueryKey, useQueryClient } from "@msuite/ui/query";
import React from "react";
import { Can } from "@/components/citadel";
import { AddContactModal } from "@/modals/contacts/add-contact-modal";

/** Props Interface */
interface ContactsMenuProps {
	queryKey: QueryKey;
}

export function ContactsMenu({ queryKey }: ContactsMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addContactModal = useDisclosure();
	const qc = useQueryClient();

	/** Functions */
	async function handleOnRefetch() {
		await qc.invalidateQueries({ queryKey });
	}

	/** Render */
	return (
		<React.Fragment>
			<Can
				action="create"
				subject="Contact"
			>
				<Button
					icon={<Icon name="Plus" />}
					variant="primary"
					onClick={addContactModal.onOpen}
					data-cy="contacts-add-contact-button"
				>
					{t("contacts.add_contact")}
				</Button>
			</Can>
			<ModalWrapper>
				{addContactModal.isOpen && (
					<AddContactModal
						isOpen={addContactModal.isOpen}
						onClose={addContactModal.onClose}
						onComplete={handleOnRefetch}
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
